export const studentsDomain = process.env.REACT_APP_NODE_ENV === "development"
  ? "http://localhost:6090"
  : (process.env.REACT_APP_NODE_ENV === "staging") ? "https://stage.vectorindia.org/" : "https://students.vectorindia.org/";

export default { studentsDomain };
